import {
  blindOrVisionLossStatusEnumSchema,
  breastCancerStatusEnumSchema,
  cervicalCancerStatusEnumSchema,
  disabledStatusEnumSchema,
  fosterCareFormerlyStatusEnumSchema,
  maritalStatusEnumSchema,
  pregnantStatusEnumSchema,
} from "@libs/api/patients";
import { i18n } from "@/i18n";

export type IncomePeriodType = "ANNUAL" | "MONTHLY" | "BI_WEEKLY";

export type IncomeRangeType = {
  value: string;
  min: number;
  max: number | null;
};

export enum SpecialConditionsEnum {
  PREGNANT_STATUS = "pregnantStatus",
  BREAST_CANCER_STATUS = "breastCancerStatus",
  CERVICAL_CANCER_STATUS = "cervicalCancerStatus",
  BLIND_OR_VISION_LOSS_STATUS = "blindOrVisionLossStatus",
  DISABLED_STATUS = "disabledStatus",
  FOSTER_CARE_FORMERLY_STATUS = "fosterCareFormerlyStatus",
}

export const SPECIAL_CONDITIONS_MAP: Record<
  SpecialConditionsEnum,
  { active: string; inactive: string }
> = {
  [SpecialConditionsEnum.PREGNANT_STATUS]: {
    active: pregnantStatusEnumSchema.enum.PREGNANT,
    inactive: pregnantStatusEnumSchema.enum.NOT_PREGNANT,
  },
  [SpecialConditionsEnum.BREAST_CANCER_STATUS]: {
    active: breastCancerStatusEnumSchema.enum.BREAST_CANCER,
    inactive: breastCancerStatusEnumSchema.enum.NOT_BREAST_CANCER,
  },
  [SpecialConditionsEnum.CERVICAL_CANCER_STATUS]: {
    active: cervicalCancerStatusEnumSchema.enum.CERVICAL_CANCER,
    inactive: cervicalCancerStatusEnumSchema.enum.NOT_CERVICAL_CANCER,
  },
  [SpecialConditionsEnum.BLIND_OR_VISION_LOSS_STATUS]: {
    active: blindOrVisionLossStatusEnumSchema.enum.BLIND_OR_VISION_LOSS,
    inactive: blindOrVisionLossStatusEnumSchema.enum.NOT_BLIND_OR_VISION_LOSS,
  },
  [SpecialConditionsEnum.DISABLED_STATUS]: {
    active: disabledStatusEnumSchema.enum.DISABLED,
    inactive: disabledStatusEnumSchema.enum.NOT_DISABLED,
  },
  [SpecialConditionsEnum.FOSTER_CARE_FORMERLY_STATUS]: {
    active: fosterCareFormerlyStatusEnumSchema.enum.FORMER_FOSTER,
    inactive: fosterCareFormerlyStatusEnumSchema.enum.NOT_FORMER_FOSTER,
  },
};

export const maritalStatusOptions = maritalStatusEnumSchema.options.map(
  option => ({
    label: i18n.t(`common:maritalStatus.${option}`),
    value: option,
  }),
);
